// this function can make a mathematical estimation of permanent wilting point
//  from field capacity. The rawPWP formula in it comes from the Semios agronomists
export const pwpFromFieldCapacity = (fieldCapacity: number) => {
  return (
    0.294 +
    36.8 * fieldCapacity * 0.01 +
    -25.2 * Math.pow(fieldCapacity * 0.01, 2) +
    386 * Math.pow(fieldCapacity * 0.01, 3) +
    -470 * Math.pow(fieldCapacity * 0.01, 4)
  )
}
